/**
 * 文本筛选
 */

define(function(require, exports, module) {

    var Base = require('c-base');

    var Filter = Base.extend({

        defaults: {
            container: null, // 筛选容器 
            tagClass: '.filter-tag', // 选项的className，默认为'filter-tag'
            selectedClass: 'selected', // 选中的选项className, 默认为'selected'
            disabledClass: 'disabled', // 选项禁用时的className，默认为'disabled'
            type: 'radio' // 选项类型，默认单选radio：单选'radio'，复选'checkbox'
        },

        initialize: function() {
            this.Parent.apply(this, arguments);

            // 容器
            this.nodeContainer = this.get('container');

            if (!this.nodeContainer) {
                throw new Error('未找到筛选容器');
                return;
            }
            // 筛选所有选项
            this.filterTags = null;

            // 单选类型存储: text
            this._radioText = null;

            // 单选类型存储: value
            this._radioValue = null;

            // 多选类型存储: text
            this._checkboxText = [];

            // 多选类型存储: value
            this._checkboxValue = [];

            // 绑定事件
            this.bindEvent();

        },

        bindEvent: function() {
            var self = this;
            var nodeContainer = this.nodeContainer;

            // 筛选模块选项点击事件
            nodeContainer.delegate(self.get('tagClass'), 'click', function(e) {
                e.preventDefault();

                var node = $(e.currentTarget);
                var value = node.attr('data-value');

                var isSelected = node.hasClass(self.get('selectedClass'));
                var isDisabled = node.hasClass(self.get('disabledClass'));

                var type = self.get('type');
                // 改选项禁用，不可选中
                if (isDisabled) {
                    return;
                }

                if (type == 'radio') { // 单选
                    if (isSelected) {
                        return;
                    } else {
                        self._radioSelect(node, value);
                    }
                } else if (type == 'checkbox') { // 多选
                    if (isSelected) {
                        self._checkboxRemove(node, value);
                        return;
                    } else {
                        self._checkboxSelect(node, value);
                    }
                }

                // 提供事件，获取选中的数据
                self.emit('select', { option: self.getValue() });
            });
        },
        /**
         * 禁用选项
         *
         * @method disabled
         * @param  {Array} data 要禁用的选项值数组
         */
        disabled: function(data) {
            var self = this;
            var nodeContainer = this.nodeContainer;
            var disabledClass = self.get('disabledClass');
            var selectedClass = self.get('selectedClass');
            var filterTags = $(this.get('tagClass'), nodeContainer);

            if ($.isArray(data) && data.length > 0) {
                $.each(filterTags, function(index, node) {
                    if ($.inArray(node.attr('data-value'), data)) {
                        node.addClass(disabledClass);
                    }
                });

                return;
            }

            filterTags.addClass(disabledClass);
        },

        /**
         * 启用选项
         *
         * @method enabled
         * @param  {Array} data 要启用的选项值数组
         * @return {[type]}      [description]
         */
        enabled: function(data) {
            var self = this;

            var nodeContainer = this.nodeContainer;

            var disabledClass = self.get('disabledClass');
            var selectedClass = self.get('selectedClass');
            var filterTags = $(this.get('tagClass'), nodeContainer);

            if ($.isArray(data) && data.length > 0) {
                $.each(filterTags, function(index, node) {
                    if ($.inArray(node.attr('data-value'), data)) {
                        node.removeClass(disabledClass);
                    }
                });

                return;
            }

            filterTags.removeClass(disabledClass);
        },

        _radioSelect: function(node, value) {
            var self = this;
            var nodeContainer = this.nodeContainer;
            var selectedClass = self.get('selectedClass');
            var filterTags = $(this.get('tagClass'), nodeContainer);

            // 清除所有选项选中状态
            filterTags.removeClass(selectedClass);

            // 添加选中样式
            node && node.addClass(selectedClass);

            // 筛选值
            self._radioValue = value;
            self._radioText = node && node.attr('data-text');
        },

        _checkboxSelect: function(node, value) {
            var self = this;

            var selectedClass = self.get('selectedClass');

            // 如果匹配值为空，将不限设为已选项
            if (!value) {
                self._checkboxText.length = 0;
                self._checkboxValue.length = 0;
                var filterTags = $(this.get('tagClass'), this.nodeContainer);;
                var selectedClass = this.get('selectedClass');
                filterTags.removeClass(selectedClass);
                return;
            }

            $.each(value.split(','), function(v) {

                if (!node) {
                    return;
                }

                node.addClass(selectedClass);

                self._checkboxText.push(node.attr('data-text'));
                self._checkboxValue.push(node.attr('data-value'));
            });
        },

        _checkboxRemove: function(node, value) {
            var self = this;

            var index = self._checkboxValue.indexOf(value);

            var selectedClass = self.get('selectedClass');

            if (value) {
                if (node) {
                    node.removeClass(selectedClass);
                }
                if (index != -1) {
                    self._checkboxText.splice(index, 1);
                    self._checkboxValue.splice(index, 1);
                }
                if (self._checkboxValue.length < 1) {
                    self._checkboxSelect();
                }
                return;
            }

            self._checkboxSelect();
        },


        getValue: function() {
            var type = this.get('type');

            if (type == 'radio') {
                return {
                    value: this._radioValue,
                    text: this._radioText
                }
            } else if (type == 'checkbox') {
                return {
                    value: this._checkboxValue, // 数组，防止外面修改了Array影响它
                    text: this._checkboxText
                }
            }
        },
        /**
         * 获取已选择的选项个数
         */
        getLength: function() {
            var type = this.get('type');

            if (type == 'radio') {
                return this._radioValue ? 1 : 0;
            } else if (type == 'checkbox') {
                return this._checkboxValue.length
            }
        },

        reset: function() {
            var filterTags = $(this.get('tagClass'), this.nodeContainer);;
            var selectedClass = this.get('selectedClass');
            var type = this.get('type');
            filterTags.removeClass(selectedClass);

            if (type == 'radio') {
                this._radioText = null;
                this._radioValue = null;
            } else if (type == 'checkbox') {
                this._checkboxValue = [];
                this._checkboxRemove = [];
            }
        }
    });
    
    UpAct.Filter = Filter;
    
    module.exports = Filter;
});



// WEBPACK FOOTER //
// ./js/lib/filter/index.js